<template>
  <div class="terms-view">
    <HeaderComp />
    <TermsAndConditions />
  </div>
</template>

<script setup lang="ts">
import HeaderComp from '@/components/HeaderComp.vue'
import TermsAndConditions from '@/components/TermsComp.vue'
</script>
